/* unplugin-vue-components disabled */import script from "./NoticeUpdateDialog.vue?vue&type=script&setup=true&name=NoticeUpdateDialog&lang=js"
export * from "./NoticeUpdateDialog.vue?vue&type=script&setup=true&name=NoticeUpdateDialog&lang=js"

import "./NoticeUpdateDialog.vue?vue&type=style&index=0&id=596491b4&scoped=true&lang=scss"
import "./NoticeUpdateDialog.vue?vue&type=style&index=1&id=596491b4&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-596491b4"]])

export default __exports__